import { Module, RegisterOptions } from "vuex-class-modules";
import ListStoreVuex from "../../../../common/src/stores/general/ListStoreVuex";
import { Api } from "../../../../common/src/api/Api";
import {
    ConferenceListItem,
    ConferenceListResponse,
} from "@gsx/common/src/types/http/dashboard/conference";
import { ConferenceFilterStore } from "./ConferenceFilterStore";

@Module({ generateMutationSetters: true })
export class ConferenceListStore extends ListStoreVuex<ConferenceListItem> {
    query: string = "";
    pageSize: number = 20;
    afterDate: Date | null = null;
    beforeDate: Date | null = null;

    constructor(
        private readonly api: Api,
        private readonly filterStore: ConferenceFilterStore,
        options: RegisterOptions,
    ) {
        super(options);
    }

    protected async fetch(): Promise<ConferenceListResponse> {
        return this.api.dashboard.conference.list({
            ...this.queryParams,
            query: this.query,
            logicalOperator: this.filterStore.logicalOperator,
            topics: Array.from(this.filterStore.topics),
            types: Array.from(this.filterStore.types),
            countries: Array.from(this.filterStore.countries).map(
                (country) => country.split(":")[1],
            ),
            cities: Array.from(this.filterStore.cities).map((city) => city.split(":")[1]),
            afterDate: `${this.afterDate?.getTime()}`,
            beforeDate: `${this.beforeDate?.getTime()}`,
        });
    }
}
